function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#6da544",
  d: "M512 85.33H0v341.333"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M446.679 85.33h-28.845L0 363.887v62.776h94.165L512 148.105V85.33z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M512 85.33h-65.321L0 383.117v43.546h65.32L512 128.876z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M186.241 265.94l18.902 14.53 19.659-13.487-7.977 22.467 18.902 14.53-23.832-.644-7.979 22.467-6.751-22.867-23.833-.644 19.66-13.487zm102.941-70.617l18.902 14.53 19.659-13.487-7.977 22.467 18.902 14.53-23.833-.645-7.978 22.468-6.752-22.867-23.832-.644 19.66-13.487z",
  fill: "#f0f0f0"
});

const SvgSaintKittsAndNevis = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSaintKittsAndNevis, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/saint-kitts-and-nevis.1ee44d6d.svg";
export { ForwardRef as ReactComponent };